import { menuAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools"; // import utility to set light and dark mode props

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(menuAnatomy.keys);

// define the base component styles
const baseStyle = definePartsStyle(props => {
  const { colorScheme: c } = props; // extract colorScheme from component props
  return {
    // define the part you're going to style
    list: {
      bg: mode(`${c}.300`, `${c}.600`)(props),
    },

    item: {
      bg: mode(`${c}.300`, `${c}.600`)(props),
      _hover: {
        bg: mode(`${c}.400`, `${c}.700`)(props),
      },
    },
  };
});

// export the component theme
export const menuTheme = defineMultiStyleConfig({
  baseStyle,
});
